import { cryptoPlugin } from './plugin.ts';

export { cryptoPlugin } from './plugin.ts';
export default cryptoPlugin;
